export const messageBoardHelper = {
    getScrollToForcedOptions: function (messageId, isAttachment) {
        return {
            scrollToForcedMessage: {
                forcedMessageId: messageId,
                isAttachment: isAttachment
            }
        };
    }
};

ep.messageBoardHelper = messageBoardHelper;